(() => {
  if (window.maxlerSprintHomeA11y) return;
  window.maxlerSprintHomeA11y = true;
  const observed = new WeakMap();
  const syncSlide = (slide) => {
    slide.toggleAttribute('inert', slide.getAttribute('aria-hidden') === 'true');
  };
  const observe = (root) => {
    root.querySelectorAll('.hero[data-slide-count]').forEach((carousel) => {
      if (observed.has(carousel)) return;
      carousel.querySelectorAll('.slideshow__slide').forEach(syncSlide);
      const observer = new MutationObserver((records) => {
        const changed = new Set();
        records.forEach((record) => {
          if (record.target.matches('.slideshow__slide')) changed.add(record.target);
        });
        changed.forEach(syncSlide);
      });
      observer.observe(carousel, {subtree: true, attributes: true, attributeFilter: ['aria-hidden']});
      observed.set(carousel, observer);
    });
  };
  observe(document);
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.hero[data-slide-count]').forEach((carousel) => {
      const observer = observed.get(carousel);
      if (!observer) return;
      observer.disconnect();
      observed.delete(carousel);
    });
  });
})();
